//
//  DocumentationLegacyPageBlockThemeType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyPageBlockThemeType;
(function (DocumentationLegacyPageBlockThemeType) {
    DocumentationLegacyPageBlockThemeType["override"] = "Override";
    DocumentationLegacyPageBlockThemeType["comparison"] = "Comparison";
})(DocumentationLegacyPageBlockThemeType || (DocumentationLegacyPageBlockThemeType = {}));
